import { createFileRoute } from "@tanstack/react-router";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminOrganizationsList from "@/common/components/views/AdminOrganizationsList";

export const Route = createFileRoute("/app/admin/organizations/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Organization", link: "/app/admin/organizations" },
        ]}
      />
      <h1>Organization Management</h1>
      <AdminOrganizationsList itemsPerPage={25} tableSize="medium" />
    </>
  );
}
